module.exports = "https://static.wmbcdn.com/uniweb/images/6bbe2cc33648321b7e87dbc6a952725f.svg";